import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'hour4u-admin-view-uploaded-image',
  templateUrl: './view-uploaded-image.component.html',
  styleUrls: ['./view-uploaded-image.component.scss']
})
export class ViewUploadedImageComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ViewUploadedImageComponent>
  ) { }

  ngOnInit() {
    console.log(this.data)
  }

}
